import apiClient from './client';
import { Client, CreateClientRequest, UpdateClientRequest } from '../types';

export const clientsApi = {
  /**
   * List all clients for the current organization
   */
  listClients: async (): Promise<Client[]> => {
    const response = await apiClient.get<Client[]>('/clients');
    return response.data;
  },

  /**
   * Create a new client
   */
  createClient: async (data: CreateClientRequest): Promise<Client> => {
    const response = await apiClient.post<Client>('/clients', data);
    return response.data;
  },

  /**
   * Get a specific client by ID
   */
  getClient: async (clientId: string): Promise<Client> => {
    const response = await apiClient.get<Client>(`/clients/${clientId}`);
    return response.data;
  },

  /**
   * Update a client
   */
  updateClient: async (
    clientId: string,
    data: UpdateClientRequest
  ): Promise<Client> => {
    const response = await apiClient.put<Client>(`/clients/${clientId}`, data);
    return response.data;
  },

  /**
   * Delete a client
   */
  deleteClient: async (clientId: string): Promise<void> => {
    await apiClient.delete(`/clients/${clientId}`);
  },
};
